window.showToast = function (kind, title, msg) {
  // kind only accept 'success', 'info', 'warning', 'error'
  toastr.options.showDuration = true
  toastr.options.closeButton = true
  toastr.options.positionClass = 'toast-bottom-right'
  toastr[kind](msg, title)
}